import { OrganizationRole } from "gitpod-next-api/gitpod/v1/organization_pb";
import { UserStatus } from "gitpod-next-api/gitpod/v1/user_pb";

export enum RoleFilterValue {
    All = "all",
    Admin = "admin",
    Member = "member",
}

export enum StatusFilterValue {
    All = "all",
    Active = "active",
    Suspended = "suspended",
}

export function roleFilterValueToApiRoles(value: RoleFilterValue): OrganizationRole[] {
    switch (value) {
        case RoleFilterValue.Admin:
            return [OrganizationRole.ADMIN];
        case RoleFilterValue.Member:
            return [OrganizationRole.MEMBER];
        case RoleFilterValue.All:
        default:
            return [];
    }
}

export function statusFilterValueToApiStatuses(value: StatusFilterValue): UserStatus[] {
    switch (value) {
        case StatusFilterValue.Active:
            return [UserStatus.ACTIVE];
        case StatusFilterValue.Suspended:
            return [UserStatus.SUSPENDED];
        case StatusFilterValue.All:
        default:
            return [];
    }
}
